import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsApiService } from 'src/app/core/api/constants-api.service';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { IGenericConstantModel } from 'src/app/core/models/interfaces/generic-constant-model';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { SprayingRequest } from 'src/app/pages/pesttrapp/models/spraying.response';
import { SprayingService } from 'src/app/pages/common/services/spraying.service';
import { DateTimeService } from 'src/app/core/services/date-time.service';

@Component({
  selector: 'app-add-spraying',
  templateUrl: './add-spraying.component.html',
  styleUrls: ['./add-spraying.component.scss'],
})
export class AddSprayingComponent implements OnInit {
  chemicalList: Array<IGenericConstantModel> = [];
  @Input() id: number;
  @Input() chemicalId: number;
  @Input() date: any = "";
  @Input() tempFarmAttrId: number;
  @Input() sprayingId: number = 0;

  constructor(private constantsApiService: ConstantsApiService,
    private loadingService: LoadingService, private modalService: ModalService,
    private sprayingService: SprayingService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private dateTimeService: DateTimeService) { }

  dismiss() {
    this.modalService.dismissByModalId(this.id, null);
  }
  ngOnInit() {

  }

  ionViewDidEnter() {
    this.getChemicalType();
  }

  getChemicalType() {
    this.loadingService.showLoading();
    this.constantsApiService.GetGroupList(1460).subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        this.chemicalList = e.Data;
      }
    });
  }


  onDateChange(ev) {
    this.date = ev;
  }

  save() {
    if (this.chemicalId) {
      let payload: SprayingRequest = {
        ChemicalTypeId: this.chemicalId,
        Date: this.dateTimeService.formatDate(this.date, "YYYY-MM-DD"),
        Id: this.sprayingId,
        TempFarmAttId: this.tempFarmAttrId
      }
      this.loadingService.showLoading();
      this.sprayingService.saveSpraying(payload).subscribe(e => {
        this.loadingService.hideLoading();
        if (e.IsSuccess) {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("spraying.save-success"), duration: 3500, type: Message_Type.SUCCESS });
          this.modalService.dismissByModalId(this.id, true, "success");
        } else {
          if (e.ValidationErrors && e.ValidationErrors.length > 0) {
            this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.ValidationErrors[0]), duration: 3500, type: Message_Type.WARNING });
          } else if (e.Message) {
            this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.Message), duration: 3500, type: Message_Type.DANGER });
          }
        }
      });
    }else{
      this.toastService.PresentBasicToast({ message: this.translateService.instant("spraying.choose-chemical-type"), duration: 3500, type: Message_Type.WARNING });
    }

  }

}
